// 側邊選單 logo
import Image from 'next/image';

const MenuLogo = ({ showMenu }) => {
    return (
        <a
            href="/"
            className={`img-box trans [&_img]:trans mx-auto [&_img]:!object-contain [&_img]:absolute
                ${
                    showMenu ? 'w-[136px] h-[137px]' : 'w-[43px] h-[46px]'
                } ulg:!w-[136px] ulg:!h-[137px]`}
        >
            {/* 小logo */}
            <Image
                className={`${!showMenu ? 'opacity-[1]' : 'opacity-[0]'} ulg:hidden`}
                src="/images/layout/mb_logo.svg"
                width={43}
                height={46}
                alt="logo"
            />
            {/* 大logo */}
            <Image
                className={`${showMenu ? 'opacity-[1]' : 'opacity-[0]'} ulg:!opacity-[1]`}
                src="/images/layout/logo.svg"
                width={136}
                height={137}
                alt="logo"
            />
        </a>
    );
};

export default MenuLogo;
